import { render, staticRenderFns } from "./AddStockRecall.vue?vue&type=template&id=27610532"
import script from "./AddStockRecall.vue?vue&type=script&lang=js"
export * from "./AddStockRecall.vue?vue&type=script&lang=js"
import style0 from "./AddStockRecall.vue?vue&type=style&index=0&id=27610532&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports